export const inviteCollaborator = {
    default: 'INVITE_COLLABORATOR.DEFAULT',
    description: 'INVITE_COLLABORATOR.DESCRIPTION',
    language: 'INVITE_COLLABORATOR.LANGUAGE',
    languageDescription: 'INVITE_COLLABORATOR.LANGUAGE_DESCRIPTION'
};
